export const adminColumnFields = ['countryCode', 'name', 'features'] as const;

export const columnFields = ['countryCode', 'name', 'features'] as const;
